/**
 * Created by Ivan on 17.03.2026
 */

const HungryGamesGuideWindow = Prefab.createWindow("hungry_games_guide_window", "hungrygamesguidewindow_prefab_json");
